import {inject, PLATFORM} from 'aurelia-framework';
import {BreakpointsService} from '../../../services/breakpoints-service';
import {ContentService} from '../../../services/content-service';
import {EventAggregator, Subscription} from 'aurelia-event-aggregator';
import {I18N} from 'aurelia-i18n';
import {ProfileImgChangedEvent, UserVisibilityChangedEvent} from '../../../aurelia-api';
import {User, UserDetails} from '../../../services/user-service';
import {SmDeviceDetected} from '../../../tools/sm-device-detected';
import {CustomerService} from '../../../services/customer-service';

@inject(BreakpointsService, EventAggregator, I18N, ContentService, UserDetails, SmDeviceDetected, CustomerService)
export class PageHeader {

  displayMenu: boolean = false;
  displayUserMenu: boolean = false;
  wnd: Window = PLATFORM.global;
  popUpHomeError: boolean = false;
  popUpHelpError: boolean = false;
  breakpoints: any;
  userData: Partial<User>;
  customHost: boolean;
  currentWidth: number;
  wideMenu: boolean;
  subscribeInvi: Subscription;
  subscribeImg: Subscription;
  userInv: boolean;

  constructor(breakpointsService: BreakpointsService, private ea: EventAggregator, private i18n: I18N, private __contentService: ContentService, private userDetails: UserDetails, private device: SmDeviceDetected, cs: CustomerService) {
    // // this.help = DOM.querySelectorAll('.help_block')[0];
    this.breakpoints = breakpointsService.getBreakPoints();
    this.customHost = cs.customHost();
    //setting screen width
    this.setWidth();
  }

  attached() {
    //set user visibility
    this.subscribeInvi = this.ea.subscribe(UserVisibilityChangedEvent, msg => this.setVisibility(msg.value));
    this.subscribeImg = this.ea.subscribe(ProfileImgChangedEvent, () => this.userDetails.update());
    //trigger event
    PLATFORM.global.dispatchEvent(new Event('86B-page-header-attached'));
  }

  detached() {
    this.subscribeInvi.dispose();
    this.subscribeImg.dispose();
  }

  setWidth() {
    this.currentWidth = this.wnd.innerWidth;
    this.wideMenu = this.currentWidth > this.breakpoints['$md-min-width'];
  }

  setVisibility(data) {
    if (typeof data === 'boolean') {
      this.userInv = data;
      PLATFORM.global.userInvisible = this.userInv;
    } else {
      this.userInv = data == 'true' ? true : false;
      PLATFORM.global.userInvisible = this.userInv;
    }
  }

  openOnebox() {
    this.__contentService.openOnebox();
  }

  openNotifications() {
    this.__contentService.openNotifications();
  }

  openGroupSettings() {
    this.__contentService.openGroupSettings();
  }

  openMenu(event) {
    let element = (event.target && event.target.tagName != 'DIV') ? event.target.parentElement : event.target;
    switch (element.id) {
    case 'userMenu':
      this.displayUserMenu = !this.displayUserMenu;
      break;
    }
    console.log(this.breakpoints);
  }

  closeMenu(event) {
    let element = event.target;
    switch (element.id) {
    case 'userMenu':
      this.displayUserMenu = false;
      break;
    }
  }

  openHelp() {
    let helpWin = PLATFORM.global.open('https://help.86borders.com', '_blank');
    // if (this.help && this.help.style) {
    //   this.help.style.display = 'block';
    // }
    console.log(helpWin);
    try {
      helpWin.focus();
    }    catch (e) {
      this.popUpHelpError = true;
    }
  }

  goHome() {
    let language = this.i18n.getLocale();
    //PLATFORM.location.replace("/?language="+language);
    let homeWin = PLATFORM.global.open('/?language=' + language, '_blank');
    console.log(homeWin);
    try {
      homeWin.focus();
    }    catch (e) {
      this.popUpHomeError = true;
    }
  }

  showBordersHome() {
    PLATFORM.global.location.href = 'https://home.86borders.com/';
  }

}
